import { AxiosRequestConfig } from "axios";
import FreespinRequestBuilder from "slotworks/integration/revolver/builders/requests/freespin-request-builder";
import SpinRequestBuilder from "slotworks/integration/revolver/builders/requests/spin-request-builder";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import PickRequestPayload from "slotworks/model/gameplay/requests/pick-request";
import { RequestBuilder } from "slotworks/server/builders/request-builder";
import { log } from "util";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";

class PickRequestBuilder implements RequestBuilder {

    public force: string;

    public paramName: string = "pick";

    public filter(data: any): boolean {
        return data instanceof PickRequestPayload;
    }

    public build(gameplay: Gameplay, data: any) {
        const pickRequestPayload = data as PickRequestPayload;

        const action: any = {};
        action[this.paramName] = pickRequestPayload.pick;
        
        if (campaignsModel.isFreespinsActive()) {
            action.availableCampaignDetails = {
                type: campaignsModel.freespins.type,
                awardId: campaignsModel.freespins.awardId
            };
        }

        if (this.force) {
            action.force = this.force;
            this.force = null;
            SpinRequestBuilder.force = null;
            FreespinRequestBuilder.force = null;
        }

        const requestConfig = {
            method: "post",
            url: RevolverModel.getBaseURL(),
            withCredentials: true,
            data: JSON.stringify({
                cmd: "RESULTS",
                session: RevolverModel.session,
                action
            })
        } as AxiosRequestConfig;


        if (RevolverModel.jwt_token) {
            requestConfig['headers'] = {
                "X-RGS-SESSION-TOKEN": RevolverModel.jwt_token
            }
        }

        return requestConfig;
    }
}

export default new PickRequestBuilder();



// WEBPACK FOOTER //
// ./~/slotworks/integration/revolver/builders/requests/pick-request-builder.ts